define('presentation/common/callDetails/presentationObjects/callDetailsRecordingPresentationObject',[],function() {
    return function(){
        const self = this;

        self.status = ko.observable("");
        self.recordingMessageId = null;
        self.recordingMessageStatus = null;
        self.recordingIsDeleted = false;
        self.recordingDeletedDateTime = null;
        self.recordingAudioUrl = null;
        self.durationInSeconds = null;
        self.canListenToRecording = false;
        self.subscriberIds = ko.observableArray([]);
        self.isDeleted = ko.observable(false);
    };
});

